import React, { useState, useEffect } from "react";
import { t } from "components/CentralDataMangement/translation/Translation";
import ModalPopup from "components/common/atoms/ModalPopup";
import LabelWithTextAreaField from "components/common/molecules/LabelWithTextAreaField";
import { validateRequired } from "components/common/services/ValidationService";

interface ArchiveModalPopupProps {
show: boolean;
onHide: () => void;
title: string;
onConfirm: (reason: string) => void;
onCancel: () => void;
isUnarchive?: boolean;
existingReason?: string | null;
}

const ArchiveModalPopup: React.FC<ArchiveModalPopupProps> = ({
show,
onHide,
title,
onConfirm,
onCancel,
isUnarchive = false,
existingReason = null,
}) => {
const [reason, setReason] = useState("");
const [reasonError, setReasonError] = useState("");

// Reset form when modal opens
useEffect(() => {
    if (show) {
    setReason("");
    setReasonError("");
    }
}, [show]);

const handleFieldChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;
    setReason(value);
    if (reasonError) {
    setReasonError("");
    }
};

const handleConfirm = () => {
    // Only validate for archive, not unarchive
    if (!isUnarchive) {
    const validationError = validateRequired(reason);
    
    if (validationError) {
        setReasonError(validationError);
        return;
    }
    }

    setReasonError("");
    onConfirm(reason);
    setReason("");
};

const handleCancel = () => {
    setReason("");
    setReasonError("");
    onCancel();
};

return (
    <ModalPopup
    show={show}
    onHide={onHide}
    title={title}
    body={
        <div>
            {isUnarchive && existingReason && (
                <div className="mt-3">
                <strong>{t("Archived reason")} : </strong>
                <span>{existingReason}</span>
                </div>
            )}
            {!isUnarchive && (
                <div className="mt-3">
                <LabelWithTextAreaField
                    name="reason"
                    label={t("Reason for archiving")}
                    handleChange={handleFieldChange}
                    value={reason}
                    isMandatory={true}
                    placeholder={t("Please provide a reason for archiving")}
                    error={reasonError}
                    rows={3}
                />
                </div>
            )}
            <p style={isUnarchive ? { marginTop: "12px", fontWeight: "bold" } : {}}>{isUnarchive ? t("Are you sure want to unarchive") : t("Are you sure want to archive")}?</p>
        </div>
    }
    onCloseButtonClick={handleCancel}
    onConfirmButtonClick={handleConfirm}
    closeTitle={t("No")}
    confirmTitle={t("Yes")}
    />
);
};

export default ArchiveModalPopup;